// extracted by mini-css-extract-plugin
export default {"buttons":"DeleteLinkModal_buttons__z4zW0","errorMessage":"DeleteLinkModal_errorMessage__W2-Fs"};